import React, { useState, useCallback, FC } from 'react';
import { Input } from '../input/Input';
import { HidePasswordIcon, ShowPasswordIcon } from '../svgs';

type TInputType = 'text' | 'password';

interface InputPasswordProps {
  value: string;
  error: boolean;
  onChange: (value: string) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;

}
export const InputPassword: FC<InputPasswordProps> = ({ value, error, onChange, onKeyDown }) => {

  const [inputType, setInputType] = useState<TInputType>('password');

  const onChangeShowPassword = useCallback(() =>
    setInputType(prev => prev === 'password' ? prev = 'text' : prev = 'password'),
    []);

  return (
    <Input
      value={value}
      error={error}
      type={inputType}
      variant={'rounded'}
      placeholder='Введите пароль'
      label={'Пароль'}
      maxLength={64}
      onChange={onChange}
      onKeyDown={onKeyDown}
      endElement={<>
        {inputType === 'password'
          ? <HidePasswordIcon
            divClassName='show-password'
            onClick={onChangeShowPassword}
          />
          : <ShowPasswordIcon
            divClassName='show-password'
            onClick={onChangeShowPassword}
          />
        }
      </>
      }
    />
  );
};
